import { render, staticRenderFns } from "./NoiseOverlay.vue?vue&type=template&id=5db137c2&scoped=true&"
import script from "./NoiseOverlay.vue?vue&type=script&lang=js&"
export * from "./NoiseOverlay.vue?vue&type=script&lang=js&"
import style0 from "./NoiseOverlay.vue?vue&type=style&index=0&id=5db137c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db137c2",
  null
  
)

component.options.__file = "NoiseOverlay.vue"
export default component.exports